var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",staticStyle:{"background":"rgba(1,1,1,0.5)"},style:({display:_vm.show?'block':'none'})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }